<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">夜樱情趣商城退换货政策</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">夜樱情趣商城退换货政策</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p class="font18">
                            <span class="font18">为了保障您的权益，给您提供更好的服务，辛苦您花1分钟了解售后服务政策。</span>
                        </p>
                        <p>
                            <span style="color:#E53333">
                                <b class="font18">一、退换货标准&nbsp;</b>
                            </span>
                            <br>
                        </p>
                        <p>
                            <span class="font18">商品完好不影响二次销售，即可享受七天退换货服务，具体标准如下：</span>
                        </p>
                        <p>
                            <span class="font18">1.商品包装完好(塑封商品未拆封)、配件、吊牌、赠品等需齐全；</span>
                        </p>
                        <p>
                            <span class="font18">2.商品未经清洗(商品消毒视为已清洗)、穿戴、使用、无人为磨损痕迹；</span>
                        </p>
                        <p>
                            <span class="font18">3.收货时如若发现异常情况，请务必拍照并及时联系客服，我们会帮您妥善处理；</span>
                        </p>
                        <p>
                            <span class="font18">4.因质量问题售后产生的运费由我们承担，非质量问题运费需由您承担；</span>
                        </p>
                        <p>
                            <span style="color: rgb(229, 51, 51); font-size: 18px;">
                                温馨提醒：商品退货，若赠品拆封或已使用，需扣除赠品费用。
                            </span>
                            <br>
                        </p>
                        <p>
                            <span style="color:#E53333">
                                <b class="font18">二、商品质保服务&nbsp;</b>
                            </span>
                            <br>
                        </p>
                        <p>
                            <span class="font18">1.	商品自签收日起7天内，满足退换货标准，则可享受退换货服务；</span>
                        </p>
                        <p>
                            <span class="font18">2.	质保期内，商品电机出现质量问题，可享受维修服务（不含配件、赠品及因使用不当造成的商品损坏），使用后商品外观破损不属于质量问题，无法提供售后维修服务；</span>
                        </p>
                        <p>
                            <span class="font18">3.	超出质保期后，商品无法提供售后服务，给您带来不便请谅解；</span>
                        </p>
                        <p>
                            <span style="font-size: 18px; color: rgb(229, 51, 51);">
                                温馨提醒：因情趣用品特殊性，安全套不支持退换；情趣内衣非质量问题不退换；实体娃娃属于定制商品，非质量问题不退换，可提供维修服务。
                            </span>
                        </p>
                        <p>
                            <span style="font-size: 18px; color: rgb(229, 51, 51);">
                                <b class="font18">三、联系方式与工作时间</b>
                            </span>
                        </p>
                        <p>
                            <span class="font18">
                                1.	售后服务：请联系在线客服
                            </span>
                        </p>
                        <p>
                            <span class="font18">
                                2.	工作时间：上午9:00-12:00，下午13:30-18:00
                            </span>
                        </p>
                        <!-- <p>
                            <span class="font18">
                                3.	非工作时间请加售后客服微信（15923998955）留言，我们会在工作时间尽快处理。
                            </span>
                        </p> -->
                        <p>
                            <span style="font-size: 18px; color: rgb(229, 51, 51);">
                                温馨提醒：若您需要退换货，请提前联系售后客服，确定可退换后，填写售后登记卡并与商品一同寄回。若您未联系客服直接退回商品，我们将无法为您处理，敬请谅解。
                            </span>
                        </p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/fukuan" style="float:left;">上一篇:如何付款？商品的付款方式是怎样的？</a>
                        <a href="/help/qianshou" class="pl10" style="float:right">下一篇:签收说明</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.font18{font-size: 18px;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/tuihuan.vue